import { PayloadAction } from "@reduxjs/toolkit";
import { DropdownDataType } from "@/shared/ui/dropdown/types";
import { DealerSliceState, IDealer, IOrderedDealer } from "../types";
import { applyDealerFilters } from "../lib/applyDealerFilters";

export const uiReducers = {
  sortDealerFilials: (
    state: DealerSliceState,
    action: PayloadAction<{ field: keyof IDealer | null; type: string | null }>,
  ) => {
    const nameSort: keyof IDealer | null = action.payload.field;
    const typeSort = action.payload.type;
    if (nameSort && typeSort !== null && state.filials.length > 1) {
      state.filials = state.filials.sort((filial1, filial2): number => {
        if (typeSort === "asc") {
          return filial1[nameSort]! > filial2[nameSort]! ? 1 : -1;
        } else if (typeSort === "desc") {
          return filial1[nameSort]! < filial2[nameSort]! ? 1 : -1;
        } else {
          return 0;
        }
      });
    }
  },
  searchDealers: (state: DealerSliceState, action: PayloadAction<string>) => {
    state.searchQuery = action.payload;
    state.dealersList = applyDealerFilters(state);
  },
  setOnlyExporters: (
    state: DealerSliceState,
    action: PayloadAction<boolean>,
  ) => {
    state.onlyExporters = action.payload;
    state.dealersList = applyDealerFilters(state);
  },
  setOnlySelfWorkers: (
    state: DealerSliceState,
    action: PayloadAction<boolean>,
  ) => {
    state.onlySelfWorkers = action.payload;
    state.dealersList = applyDealerFilters(state);
  },
  setMyDealers: (state: DealerSliceState, action: PayloadAction<boolean>) => {
    state.onlyMyDealers = action.payload;
  },
  resetDealerFilters: (state: DealerSliceState) => {
    state.onlyExporters = false;
    state.onlySelfWorkers = false;
    state.onlyMyDealers = false;
    state.searchQuery = "";
    state.dealersList = applyDealerFilters(state);
  },
  setCurrentDealer: (
    state: DealerSliceState,
    action: PayloadAction<IDealer | null>,
  ) => {
    state.currentDealer = action.payload;
  },
  setFilialSortRules: (
    state: DealerSliceState,
    action: PayloadAction<DealerSliceState["filials"]>,
  ) => {
    state.filials = action.payload;
  },
  setLoading: (state: DealerSliceState, action: PayloadAction<boolean>) => {
    state.isLoading = action.payload;
  },
  setSelectedFilials: (
    state: DealerSliceState,
    action: PayloadAction<DropdownDataType[]>,
  ) => {
    state.selectedFilials = action.payload;
  },
  setSelectedDealerIds: (
    state: DealerSliceState,
    action: PayloadAction<string[]>,
  ) => {
    state.selectedDealerIds = action.payload;
  },
  setIsDatePickerActive: (
    state: DealerSliceState,
    action: PayloadAction<boolean>,
  ) => {
    state.isDatePickerActive = action.payload;
  },
  setDealerSort: (
    state: DealerSliceState,
    action: PayloadAction<{ field: keyof IOrderedDealer }>,
  ) => {
    const { field } = action.payload;
    if (state.dealerSort.field === field) {
      state.dealerSort.type = state.dealerSort.type === "asc" ? "desc" : "asc";
    } else {
      state.dealerSort.field = field;
      state.dealerSort.type = "asc";
    }

    if (state.orderedDealers.length > 1) {
      state.orderedDealers = [...state.orderedDealers].sort((a, b) => {
        const aVal = a[field];
        const bVal = b[field];
        if (aVal == null) return 1;
        if (bVal == null) return -1;
        if (state.dealerSort.type === "asc") {
          return aVal > bVal ? 1 : -1;
        }
        return aVal > bVal ? -1 : 1;
      });
    }
  },
};
